export default __webpack_public_path__ + "static/media/graph.fd13c62e.svg";